export const sortRecordAlphabetically = <T>(record: Record<string, T>): Record<string, T> => {
    // Get the keys, sort them alphabetically, and create a new sorted Record
    const sortedKeys = Object.keys(record).sort((a, b) => a.localeCompare(b));
    
    // Reconstruct the record in sorted order
    const sortedRecord: Record<string, T> = {};
    for (const key of sortedKeys) {
        sortedRecord[key] = Array.isArray(record[key]) ? sortArrayAlphabetically(record[key] as unknown as any[]) as unknown as T : record[key];
    }
    
    return sortedRecord;
}

export const sortArrayAlphabetically = <T>(array: T[]) => {
    return array.slice().sort();
}